import { useParams, Navigate } from 'react-router-dom';
import PageLayout from '../components/PageLayout';
import PageHeader from '../components/PageHeader';
import { HelpArticleCard, HelpBreadcrumb } from '../components/help';
import { useHelpCategory } from '../hooks/useHelpArticles';
import type { HelpCategory } from '../types/help';

export default function HelpCategoryPage() {
  const { category } = useParams<{ category: string }>();
  const { articles, meta } = useHelpCategory(category as HelpCategory);

  // Redirect if category doesn't exist
  if (!meta) {
    return <Navigate to="/help" replace />;
  }

  return (
    <PageLayout maxWidth="standard" title={meta.title}>
      <HelpBreadcrumb
        items={[
          { label: 'Help Center', href: '/help' },
          { label: meta.title },
        ]}
      />

      <PageHeader title={meta.title} subtitle={meta.description} />

      {/* Article list */}
      {articles.length > 0 ? (
        <div className="space-y-3">
          {articles.map((article) => (
            <HelpArticleCard key={article.slug} article={article} />
          ))}
        </div>
      ) : (
        <div
          className="rounded-lg border p-8 text-center"
          style={{
            backgroundColor: 'var(--oro-surface)',
            borderColor: 'var(--oro-border)',
          }}
        >
          <p style={{ color: 'var(--text-secondary)' }}>
            No articles in this category yet.
          </p>
        </div>
      )}
    </PageLayout>
  );
}
